import { Controller } from "stimulus"
import * as Turbo from "@hotwired/turbo"

// Makes the whole debt quest mission card navigate to the mission's "insight"
// (its quest page). The explicit controls inside the card — Begin/Continue,
// Insight, and Edit — keep their native navigation: a click that lands on any
// link or button is left to that control (so Edit still goes to edit), and only
// bare-surface clicks fall through to the insight. Locked cards carry no url and
// are inert.
export default class extends Controller {
  static values = { url: String }

  navigate(event) {
    if (!this.urlValue) return
    // Defer to any interactive control the activation landed on (Begin/Continue,
    // Insight, Edit) so their own destinations win — for both mouse and keyboard.
    if (event.target.closest("a, button")) return

    if (event.type === "keydown") {
      // Card carries role="link"/tabindex; activate it like a link does — Enter
      // only (Space scrolls for links), and ignore auto-repeat on key hold.
      if (event.repeat) return
      if (event.key !== "Enter") return
    } else if (window.getSelection().toString().length > 0) {
      return // a click that was really the end of a text selection
    }

    Turbo.visit(this.urlValue)
  }
}
